import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import IconEstado from "../../../../autorizaciones/UI/IconEstado";
import { RECLAMOS_MENU_EFECTOR_INFORMACION } from "../../../../../utils/constants";
import { EfectorMenu } from "../ModalDetalleReclamo/EfectorMenu";
import { InformacionReclamoEfector } from "../ModalDetalleReclamo/InformacionReclamoEfector";
import { DocumentacionReclamoEfectorMenu } from "../ModalDetalleReclamo/DocumentacionReclamoEfectorMenu";
import { DerivacionesReclamosEfectoresMenu } from "../ModalDetalleReclamo/DerivacionesReclamosEfectoresMenu";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        name={index}
        {...other}
      >
        {value === index && <Box p={2}>{children}</Box>}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

export const ModalComentariosReclamosEfector = (props) => {

    const { solicitudSeleccionada = {}, dataEfector } = useSelector((state) => state.reclamos);
    const [selectedTab, setSelectedTab] = useState(
        RECLAMOS_MENU_EFECTOR_INFORMACION.EFECTOR
    );
    const { fechaFin, fechaInicio} = props;
  
    const disabled = props.disabled;


    
  return (
    <>
    <Dialog
      fullWidth
      maxWidth="lg"
      open={props.open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>
        <span style={{ float: "left" }}>
          Resumen - ID Caso: {props.solicitud?.id}
        </span>
 
          {dataEfector?.fechaBaja !== null && (
            <>
               {/* Espacios en blanco */}
              <span style={{ color: "red",  marginLeft: '10px' }}>(EFECTOR DE BAJA)</span>
            </>
          )}

        <br />
        <div>
            <span style={{ marginRight: '10px' }}>
              Categoría: {solicitudSeleccionada?.descripcionCategoriaReclamo}
            </span>

        </div>
        {props.solicitud?.urgente === 1 ? (
          <div>
            Urgente:
            <span style={{ marginRight: '10px' }}></span>
            <IconEstado
              useColorTable={true}
              texto={solicitudSeleccionada?.letraUrgente}
              backgroundColor={solicitudSeleccionada?.colorUrgente}
              descripcion={solicitudSeleccionada?.descripcion}
            />
          </div>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(_event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={RECLAMOS_MENU_EFECTOR_INFORMACION.EFECTOR}
            label="EFECTOR"
            {...a11yProps(RECLAMOS_MENU_EFECTOR_INFORMACION.AFILIADO)}
          />
          <Tab
            value={RECLAMOS_MENU_EFECTOR_INFORMACION.INFORMACION}
            label="Información / Comentarios"
            {...a11yProps(RECLAMOS_MENU_EFECTOR_INFORMACION.INFORMACION)}
          />
          <Tab
            value={RECLAMOS_MENU_EFECTOR_INFORMACION.DOCUMENTACION}
            label="Documentación"
            {...a11yProps(RECLAMOS_MENU_EFECTOR_INFORMACION.DOCUMENTACION)}
          />
          <Tab
            value={RECLAMOS_MENU_EFECTOR_INFORMACION.DERIVACIONES}
            label="Administrar"
            {...a11yProps(RECLAMOS_MENU_EFECTOR_INFORMACION.DERIVACIONES)}
          />
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={RECLAMOS_MENU_EFECTOR_INFORMACION.EFECTOR}
        >
          <EfectorMenu efector={solicitudSeleccionada?.idEfectorFacturacion}   solicitud={solicitudSeleccionada}/>
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={RECLAMOS_MENU_EFECTOR_INFORMACION.INFORMACION}
        >
          <InformacionReclamoEfector
            solicitud={solicitudSeleccionada}
            onCloseModalAuditar={props.closeModalHandler}
            disabled={disabled}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={RECLAMOS_MENU_EFECTOR_INFORMACION.DOCUMENTACION}
        >
          <DocumentacionReclamoEfectorMenu
            onCloseModalAuditar={props.closeModalHandler}
            solicitud={solicitudSeleccionada}
            disabled={disabled}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={RECLAMOS_MENU_EFECTOR_INFORMACION.DERIVACIONES}
        >
          <DerivacionesReclamosEfectoresMenu
            disabled={disabled}
            onCloseModalAuditar={props.closeModalHandler}
            fechaFin={fechaFin}
            fechaInicio= {fechaInicio}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  </>
  )
}
